import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs";
import LoadingScreen from "../../components/LoadingScreen";
import ErrorContent from "../../components/ErrorContent";
import LoadingButton from "../../components/LoadingButton";
import { Post, Area, PostSlug } from "../../grpc/dash/v1/models_pb";
import { areaServiceListAreas } from "../../api/area";
import { postServiceGetPost, postServicePutPost } from "../../api/post";
import { entity, postStatus, postType, status } from "../../api/types";
import Editor from "../../components/EditorComponent/Editor";
import FAQs from "../../components/FAQs";

function PostEdit() {
    let { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState(
        new Post()
            .setArea(new Area.Simple())
            .toObject());
    const [areas, setAreas] = useState([]);
    const [breadcrumbData, setBreadcrumbData] = useState(null);

    const loadAreas = async () => {
        console.log(data)
        const response = await areaServiceListAreas();
        setAreas(response.toObject().areasList);
    }

    const loadScreen = async () => {
        try {
            await loadAreas();

            const breadcrumbItems = [{ name: "YAZILAR", url: "/posts" }];
            if (id === undefined) {
                breadcrumbItems.push({ name: "YENİ", url: "" });
            } else {
                const result = await postServiceGetPost(id);
                setData(result.toObject().post)
                breadcrumbItems.push({ name: `#${id}`, url: "" });
            }
            setBreadcrumbData(breadcrumbItems);
            setLoading(false);
        } catch (err) {
            setError(err);
            setLoading(false);
        }
    }
    const setCustomData = (key, value) => {

        switch (key) {
            case "areaId":
                data.area.id = parseInt(value);
                break;
            case "status":
            case "postType":
                data[key] = parseInt(value);
                break;
            default:
                data[key] = value;
                break;
        }

        console.log(data)
        setData({ ...data })
    }
    const onPressForm = async (e) => {
        e.preventDefault();
        console.log(data)
        try {
            let result = await postServicePutPost({
                id: data.id,
                areaId: data.area.id,
                title: data.title,
                description: data.description,
                content: data.content,
                postType: data.postType,
                status: data.status,
                seoTitle: data.seoTitle,
                seoDescription: data.seoDescription,
            });
            navigate(`/posts?areaId=${result.toObject().post.area.id}`);
        } catch (err) {
            console.log(err);
            setError(err);
        }
    }
    const RenderContent = () => {
        if (loading)
            return <LoadingScreen />;
        if (error !== null)
            return <ErrorContent error={error} />
        return <form className="card-body row g-3">

            <div className="col-md-6 py-1">
                <label htmlFor="form-area" className="form-label">ALAN</label>
                <select id="form-area" className="form-select" defaultValue={data.area?.id} onChange={e => setCustomData("areaId", e.target.value)}>
                    <option key={`area-0`} value={0}>Belirtilmemiş</option>
                    {
                        areas.map((item, index) => <option key={`area-${index}`} value={item.id}>{item.title}</option>)
                    }
                </select>
            </div>
            <div className="col-md-3 py-1">
                <label htmlFor="form-post-type" className="form-label">TİP</label>
                <select id="form-post-type" className="form-select" defaultValue={data.postType} onChange={e => setCustomData("postType", e.target.value)}>
                    {
                        Object.values(postType()).map((value, index) => (
                            <option key={"status" + index} value={index}>{postType(value)}</option>
                        ))
                    }
                </select>
            </div>
            <div className="col-md-3 py-1">
                <label htmlFor="form-status" className="form-label">DURUM</label>
                <select id="form-status" className="form-select" defaultValue={data.status} onChange={e => setCustomData("status", e.target.value)}>
                    {
                        Object.values(postStatus()).map((value, index) => (
                            <option key={"status" + index} value={index}>{postStatus(value)}</option>
                        ))
                    }
                </select>
            </div>

            <div className="col-md-6 py-1">
                <label htmlFor="form-title" className="form-label">BAŞLIK</label>
                <input type="text" className="form-control" id="form-title" value={data.title} onChange={e => setCustomData("title", e.target.value)} />
            </div>
            <div className="col-md-6 py-1">
                <label htmlFor="form-seo-title" className="form-label">SEO BAŞLIK</label>
                <input type="text" className="form-control" id="form-seo-title" value={data.seoTitle} onChange={e => setCustomData("seoTitle", e.target.value)} />
            </div>
            <div className="col-md-6 py-1">
                <label htmlFor="form-description" className="form-label">AÇIKLAMA</label>
                <input type="text" className="form-control" id="form-description" value={data.description} onChange={e => setCustomData("description", e.target.value)} />
            </div>
            <div className="col-md-6 py-1">
                <label htmlFor="form-seo-description" className="form-label">SEO AÇIKLAMA</label>
                <input type="text" className="form-control" id="form-seo-description" value={data.seoDescription} onChange={e => setCustomData("seoDescription", e.target.value)} />
            </div>

            <div className="col-md-12 py-1">
                <label className="form-label">İÇERİK</label>
                <Editor
                    value={data.content}
                    setValue={(value) => {
                        setCustomData("content", value)
                    }}
                />
            </div>
            <div className="col-md-8 py-1">
                <table className="table">
                    <thead><tr><th>Bağlantı</th></tr></thead>
                    <tbody>
                        {data.slugsList
                            .sort((a, b) => { return b.createdAt.seconds - a.createdAt.seconds; })
                            .map((item, index) => {
                                return <tr scope="row" key={"slug_" + index}><td>
                                    <span className="badge text-bg-light">{new Date(item.createdAt.seconds * 1000).toLocaleString("tr")}</span>
                                    <span className={index == 0 ? "badge text-bg-success" : "badge text-bg-secondary"}>{item.value}</span>

                                </td></tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            <div className="col-12">
                <LoadingButton onClick={onPressForm} Text="KAYDET" />
            </div>

            <FAQs entity={entity().ENTITY_POST} entityId={id} />
        </form >
    };
    useEffect(() => {
        loadScreen();
    }, []);
    return <div className="container">
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <Breadcrumbs data={breadcrumbData} />
            </div>
            {RenderContent()}
        </div>
    </div>;
}

export default PostEdit;